<div class="modal-dialog modal-dialog-centered modal-sm">
  <div class="modal-content">
    <div class="modal-header">
      <b class="modal-title container" i18n>Informações do Lote</b>
      <button type="button" (click)="onClose()" class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <app-enum-i18n [input]="lotSteps" (output)="setLotStepsI18n($event)"></app-enum-i18n>
    <app-enum-i18n [input]="statusLot" (output)="setLotStatusI18n($event)"></app-enum-i18n>

    <div class="modal-body" *ngIf="loading; else loadingBlock" #container>
      <div class="container">
        <div class="capture-block">
          <table class="table table-bordeless table-striped data-table">
            <thead>
              <tr>
                <th class="text-center">Lote</th>
                <th class="text-center">Status</th>
                <th class="text-center">Tipo</th>
                <th class="text-center">Responsável</th>
                <th class="text-center">Última Modificação</th>
              </tr>
            </thead>
            <tbody *ngFor="let lotStep of lotStepsI18n; index as i">
              <tr *ngFor="let historyStep of historiesByStep[lotStep.id]">
                <td class="text-center">{{lot.name}}</td>
                <td class="text-center">{{getStatusLot(historyStep.status)}}</td>
                <td class="text-center">{{lotStep.value}}</td>
                <td class="text-center">{{historyStep?.authorName || '-'}}</td>
                <td class="text-center">
                  {{historyStep.updatedAt | moment: 'L LTS' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loadingBlock>
    <div class="loading-page">
      <div class="loading-spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </ng-template>
</div>
